const BOOKABLE_EDUCATOR_PAGE_SIZE = 50

/**
 * Request model for `POST /candidate/bookable`.
 *
 * @typedef {Object} BookableEducatorSchedule
 * @property {string} dateLocal - Date in yyyy-MM-dd format.
 * @property {string} startTime - Start time in H:mm format.
 * @property {string} endTime - End time in H:mm format.
 *
 * @typedef {Object} BookableEducatorQueryRequestDTO
 * @property {BookableEducatorSchedule[]} schedules - Booking schedule entries.
 * @property {number[]} certificationIds - Required certification IDs.
 * @property {number|null} classificationId - Selected booking classification ID.
 * @property {number[]} candidateTypeIds - Optional educator type filter IDs.
 * @property {number|null} locationId - Client location ID.
 * @property {string|null} sortOrder - `CandidateSortOrder` enum value (e.g. nameAsc).
 * @property {string} searchTerm - Free text search term.
 * @property {number} pageNumber - 1-based page number.
 * @property {number} pageSize - Results per page (default 50).
 */
export class BookableEducatorQueryRequestDTO {
  constructor({
    schedules,
    certificationIds,
    classificationId,
    candidateTypeIds,
    locationId,
    sortOrder,
    searchTerm,
    pageNumber,
    pageSize,
  } = {}) {
    this.schedules = schedules ?? []
    this.certificationIds = certificationIds ?? []
    this.classificationId = classificationId ?? null
    this.candidateTypeIds = candidateTypeIds ?? []
    this.locationId = locationId ?? null
    this.sortOrder = sortOrder ?? null
    this.searchTerm = searchTerm ?? ''
    this.pageNumber = pageNumber ?? 1
    this.pageSize = pageSize ?? BOOKABLE_EDUCATOR_PAGE_SIZE
  }
}
